import React, {Component} from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';

import {mesAutobind} from '@posco/posco-shared';
import {Button, Checkbox, DatePicker, Input} from '@posco/posco-ui-react';
import {FindUserModal, FindVendorModal} from "@plm/o10-share-front";
import moment from 'moment';

@mesAutobind
@observer
class O10g015350 extends Component {
  /**회원가입(외부공급사 권한 신청 팝업)**/

  static propTypes = {
    folding: PropTypes.bool,
  };

  static defaultProps = {
    folding: false,
  };

  state = {
    open : false,
    agree1: false,
    securityAgree: false,
    period: [moment().add(1, 'days').format('YYYY-MM-DD'), moment().add(1, 'year').format('YYYY-MM-DD')],
    periodDV: [moment().add(1, 'days').format('YYYY-MM-DD'), moment().add(1, 'days').format('YYYY-MM-DD')],
    popupOpen: false,
    selectedVendor: '',
    selectedUser: '',
    userModalOpen: false,
    pmModalOpen:false,
    vendorId: "",
    phone: "",
    email: "",
    userId: "",
  };


  handleSave() {
    console.log('save');
  }

  handleCancel() {
    console.log('cancel');
  }

  /**모달 닫기**/
  onClose() {
    // this.props.o10g015460Store.changeDisabled(true);
    this.props.close();
  }


  handleChange(data) {
    this.setState(data.changed);
    this.props.changeHandle(data.changed);
  }


  handleClickVendorButton() {
    this.setState({vendorModalOpen: true});
  }

  handleClose() {
    this.setState({vendorModalOpen: false});
  }
  handleClickUserButton() {

    console.log("value1111111+++",  this.props.value1);
    console.log("userButton+++",  this.state.selectedVendor.vendorId)
    this.setState({userModalOpen: true, vendorId: this.state.selectedVendor.vendorId});
  }

  handleCloseUser() {
    this.setState({userModalOpen: false, vendorId: ""});
  }

  handleClickPmButton() {
    console.log("pmButton+++")
    this.setState({userModalOpen: true, vendorId: "3050"});

  }

  onChange(e, data) {
    console.log("data===", data);
    let inputVal = data.value;

    let cleanedUserIdVal = null;
    let cleanedInputVal = null;
    let cleanedEmailVal = null;

    if (data.id === "userId") {
      console.log("userId data.id=====", data.id);
      if (inputVal) {
        // 영문 소문자와 숫자만 허용하는 정규식 적용
        cleanedUserIdVal = inputVal.replace(/[^a-z0-9]/ig, '').toLowerCase();
        console.log("cleanedUserIdVal::", cleanedUserIdVal);
      }
      this.setState({userId: cleanedUserIdVal});
    }

    if (data.id === "phone") {
      console.log("phone data.id=====", data.id);
      if (inputVal) {
        // 정규표현식을 사용하여 숫자와 '-'만 입력받도록 함
        cleanedInputVal = inputVal.replace(/[^0-9-]/g, '');
        console.log("cleanedInputVal::", cleanedInputVal);
      }
      this.setState({phone: cleanedInputVal});
    }

    if (data.id === "email") {
      console.log("email data.id=====", data.id);
      if (inputVal) {
        // 정규표현식을 사용하여 영문 대/소문자, 숫자, 기호(_), 기호(-), 기호(@), 점(.)만 입력받도록 함
        cleanedEmailVal = inputVal.replace(/[^a-zA-Z0-9_@.\-]/g, '');
        console.log("cleanedEmailVal::", cleanedEmailVal);
      }
      this.setState({email: cleanedEmailVal});
    }
  }

  handleClosePm() {
    this.setState({userModalOpen: false, vendorId: ""});
  }

  handleConfirm(data) {
    this.setState({
      selectedVendor: data,
    });
    this.props.changeHandle({isFamily: data.vendorAreaType === 'Y'});
  }

  clearVendor() {
    this.setState({
      selectedVendor: null
    });
  }


  clearUser() {
    this.setState({user: null});
  }

  onClick() {
    alert('팝업 임시');
  }

  handleChangeDate(changedDate) {
    this.setState({period: changedDate});
  }

  onDatePickerClick() {
    if (this.val) {
      this.setState({
        periodDV: [moment().add(-1, 'month'), moment()],
        period: [moment().add(-1, 'month'), moment()],
      });
      this.val = false;

    } else {
      this.setState({
        periodDV: [moment().add(-1, 'month'), moment()],
      });
    }

    this.props.changeHandle({period: [moment().add(-1, 'month'), moment()]});
  }


  render() {
    //
    const {
      changeHandle
    } = this.props;

    const {agree1, securityAgree, selectedVendor, vendorModalOpen,  selectedUser, isFamily} = this.state;

    return (
      <>
        <div className="gridRow twoColumn">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>회사명</h4>
            </div>
            <div className="srcWrap withBtn">
              <Input
                disabled
                width={300}
                id={'vendorName'}
                value={selectedVendor ? selectedVendor.vendorName : ''}
              /><Input
              disabled
              width={50}
              id={'vendorId'}
              value={selectedVendor ? selectedVendor.vendorId : ''}
            />
              <Button content="검색" className="btnSearch mgl-16" onClick={this.handleClickVendorButton}/>
              <FindVendorModal
                size={'large'}
                open={vendorModalOpen}
                close={() => {
                  this.handleClose();
                }}
                onApply={(selected) => {
                  this.setState({
                    selectedVendor: {
                      vendorName: selected.vendorName,
                      vendorId: selected.vendorId,
                      phone: selected.customerNumber //인증서 사용시 필요 코드
                    },
                    /**isFamily: (그룹사) 포스코건설 689 , 포스코ICT 1149 , 포스코플랜텍 592**/
                    isFamily: selected.vendorAreaType === 'Y'
                  }, () => {
                    this.props.changeHandle({isFamily: selected.vendorAreaType === 'Y'});
                    console.log("this.state.isFamily", this.props.isFamily);
                    this.handleClose();
                  })
                }}
                gcsCompCode={'01'}
                enabledFlag={'Y'}
              />
              <Button className="btnSearch mgl-16" onClick={this.clearVendor}>clear</Button>
            </div>
          </div>
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>이름</h4>
            </div>
            <div className="srcWrap">
              {
                !selectedVendor || isFamily ? (
                  <>
                    { console.log("selectedVendor==", selectedVendor)}
                    <Input
                      readOnly={!selectedVendor || isFamily}
                      id={'subcNm'}
                      // value={this.state.pm}
                      value={selectedUser ? selectedUser.name : ''}
                    />
                    <Button disabled={isFamily ? false : true} content="검색" onClick={this.handleClickUserButton}/>
                    <Button content="clear" onClick={this.clearUser}/>

                  </>
                ) : (
                  <>
                    <Input
                      id={'subcNm'}
                      maxLength={'6'}

                    />
                  </>
                )
              }
            </div>
          </div>
        </div>
        <div className="gridRow twoColumn">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>회사전화번호</h4>
            </div>
            <div className="srcWrap">
              {
                !selectedVendor || isFamily ? (
                  <>
                    <Input
                      readOnly={!selectedVendor || isFamily}
                      id={'phone'}
                      value={selectedUser ? selectedUser.phone : ''}
                    />
                  </>
                ) : (
                  <>
                    <Input
                      id={'phone'}
                      maxLength={'20'}
                      onChange={this.onChange}
                      value = {this.state.phone}
                    />
                  </>
                )
              }
            </div>
          </div>
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>E-Mail</h4>
            </div>
            <div className="srcWrap">
              {
                !selectedVendor || isFamily ? (
                  <Input
                    readOnly={!selectedVendor || isFamily}
                    id={'email'}
                    value={selectedUser ? selectedUser.email : ''}
                  />
                ) : (
                  <Input
                    readOnly={!selectedVendor || isFamily}
                    id={'email'}
                    maxLength={'50'}
                    onChange={this.onChange}
                    value = {this.state.email}
                  />
                )
              }
            </div>
          </div>
        </div>
        <div className="gridRow twoColumn">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>프로젝트명</h4>
            </div>
            <div className="srcWrap">
              <Input id={'projectName'} maxLength={30}/>
            </div>
          </div>
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>ID</h4>
            </div>
            <div className="srcWrap withText"  style={{"justifyContent": "normal"}}>
              {
                !selectedVendor || isFamily ? (
                  <>
                    <Input
                      readOnly={!selectedVendor || isFamily}
                      width={300}
                      maxLength={20}
                      id={'userId'}
                      value={selectedUser ? selectedUser.ID : ''}
                    />
                  </>
                ) : (
                  <>
                    {!isFamily ? 'sup-' : ''}
                    <Input
                      readOnly={!selectedVendor || isFamily}
                      width={300}
                      maxLength={20}
                      id={'userId'}
                      onChange={this.onChange}
                      value = {this.state.userId}
                    />
                  </>
                )
              }
            </div>
          </div>
        </div>
        <div className="gridRow twoColumn">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>사용기간</h4>
            </div>
            <div className="srcWrap">
              <DatePicker period
                          defaultValue={this.state.periodDV}
                          value={this.state.period}
                          onChange={(value) => {
                            this.handleChangeDate(value);
                            changeHandle({period: value});
                          }}
              >
                <Input width="200px" icon="calendar alternate outline" onClick={this.onDatePickerClick}/>
              </DatePicker>
              {/*<Input style={{display:'none'}} id={'dateFrom'}/>*/}
              {/*<Input style={{display:'none'}} id={'dateTo'}/>*/}
            </div>
          </div>
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>포스코PM</h4>
            </div>
            <div className="srcWrap withBtn">
              <Input
                readOnly
                // width={900}
                // value={this.state.pm}
                placeholder={this.state.pm ? `${this.state.pm.name}(${this.state.pm.number})` : ''}
              />
              <Button className="btnSearch mgl-16" content="검색" onClick={this.handleClickPmButton}/>
              <Button className="btnSearch mgl-16" onClick={this.clearUser}>clear</Button>
            </div>
          </div>
        </div>
        <Input
          value={this.state.pm ? this.state.pm.number : ''}
          type={'hidden'}
          id={'chargeEmpNum'}
        />
        <div className="gridRow">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>신청사유</h4>
            </div>
            <div className="srcWrap">
              <Input
                id={'reason'}
                maxLength={100}
              />
            </div>
          </div>
        </div>
        <div className="gridRow">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>개인정보수집/이용동의서</h4>
              <div>
                <Checkbox
                  id={'agree1'}
                  name="agree1"
                  checked={agree1}
                  onChange={(e, data) => {
                    this.handleChange(data);
                  }}
                  label="동의합니다."
                />
              </div>
            </div>
            <div style={{height: "130px", overflow: "auto", padding: "5px", border:"1px solid #dcdcdc"}}>
              <div
                dangerouslySetInnerHTML={{__html: this.props.user030s.manPrcStexExpl2}}>
              </div>
            </div>
          </div>
        </div>
        <div className="gridRow">
          <div className="gridColumn">
            <div className="h4wrap">
              <h4>보안서약서</h4>
              <div>
                <Checkbox
                  id={'securityAgree'}
                  name="securityAgree"
                  checked={securityAgree}
                  onChange={(e, data) => {
                    this.handleChange(data);
                  }}
                  label="동의합니다."
                />
              </div>
            </div>
            <div style={{height: "130px", overflow: "auto", padding: "5px", border:"1px solid #dcdcdc"}}>
              <div
                dangerouslySetInnerHTML={{__html: this.props.user030s.manPrcStexExpl3}}>
              </div>
            </div>
          </div>
        </div>

        <FindUserModal
          size={'large'}
          open={this.state.userModalOpen}
          close={() => {
            this.handleCloseUser();
          }}
          onApply={(selected) => {
            {
              {console.log("포스코피엠/user vendorId==",  this.state.vendorId)}
              this.state.vendorId === '3050' ?
                this.setState({
                  pm: {
                    name: selected.employeeName,
                    number: selected.employeeNumber
                  }
                })
                :
                this.setState({
                  selectedUser: {
                    name: selected.employeeName,
                    number: selected.employeeNumber,
                    phone: selected.workTelephone,
                    email: selected.emailAddress,
                    ID: selected.smrtNoteUserId
                  }
                });
            }
            this.handleCloseUser();
          }}
          gcsCompCode={'01'}
          multi={false}
          onlyActive={true}
          vendorId={this.state.vendorId}
        />
      </>

    );
  }
}


export default O10g015350;
